import { render, staticRenderFns } from "./TabMenus.vue?vue&type=template&id=3d33f82e&scoped=true&lang=true&"
import script from "./TabMenus.vue?vue&type=script&lang=js&"
export * from "./TabMenus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d33f82e",
  null
  
)

export default component.exports